import React, { useContext } from 'react';
import { OptionsContext } from './context';
import { BlockRenderer } from './BlockRenderer';
export const Blocks = React.memo((props) => {
    const { blocks } = props;
    const { plugins } = useContext(OptionsContext);
    return (React.createElement(React.Fragment, null, blocks.map(b => (React.createElement(BlockRenderer, { block: b, key: b.id, plugin: plugins[b.plugin] })))));
});
